<sim-side-panel>
  <div sidePanelHeader class="detail-panel__header">
    <div class="detail-panel__title">
      @if (thumbnailUrl()) {
        <img [src]="thumbnailUrl()" [alt]="heading()" class="detail-panel__thumb-img" />
      } @else {
        <sim-icon [icon]="icon()" color="var(--text-icon)" [sizeInPx]="iconSizeInPx()" />
      }
      <span class="detail-panel__name" simEllipsisTooltip>{{ heading() }}</span>
    </div>

    <div class="detail-panel__actions">
      @if (canEdit()) {
        <button
          sim-icon-button
          class="detail-panel__icon-button detail-panel__menu-button"
          [simMenuTriggerFor]="actionMenu"
        >
          <sim-icon icon="more" color="var(--text-icon)" [sizeInPx]="20" />
        </button>
        <sim-menu-panel #actionMenu>
          <button sim-menu-item (click)="edit.emit()">
            <sim-icon icon="drive_file_rename_outline" [sizeInPx]="20" />
            <ng-container i18n="@@EDIT">Edit</ng-container>
          </button>
          <button sim-menu-item class="detail-panel__delete-item" (click)="remove.emit()">
            <sim-icon icon="delete" color="var(--danger, #cd3f3e)" [sizeInPx]="20" />
            <ng-container i18n="@@GENERAL_DELETE">Delete</ng-container>
          </button>
        </sim-menu-panel>
      }

      <button sim-icon-button class="detail-panel__icon-button" (click)="closePanel.emit()">
        <sim-icon icon="close2" color="var(--text-icon)" [sizeInPx]="24" />
      </button>
    </div>
  </div>

  <div sidePanelContent class="detail-panel__content">
    <ng-content />
    <ng-content select="[detailPanelActivity]" />
  </div>

  <div sidePanelFooter class="detail-panel__footer">
    <ng-content select="[detailPanelToolbar]" />
  </div>
</sim-side-panel>
